import type { PropsWithChildren } from 'react'
import { Popper as MuiPopper, type PopperProps } from '@mui/material'

export const Popper = ({ style, ...props }: PropsWithChildren<PopperProps>) => (
  <MuiPopper {...props} style={{ minWidth: style?.width, maxWidth: 'fit-content' }} placement="bottom-start" />
)
